import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
/*
const ButtonBGWeb = styled("div", ({ $theme }) => ({
    background: $theme.buttonBackground,
}));
*/
export const HiylloBGContext = React.createContext(null);
export const HiylloBG = React.memo(function HiylloBG(props) {
    const C = React.useContext(HiylloBGContext);
    if (C == null) {
        throw new Error("HiylloBGContext is null");
    }
    return _jsx(C, { ...props });
});
export const HiylloBGProvider = React.memo(function HiylloBGProvider(props) {
    return _jsx(HiylloBGContext.Provider, { value: props.component, children: props.children });
});
